import React, { useEffect, useMemo, useState } from 'react';
import ReactSelect from 'react-select';
import ProductStock from './ProductStock';
import clsx from 'clsx';

const VariantsPicker = ({
  choices,
  variantsPickerItems,
  onSelect,
  classPrefix,
}) => {
  const [chosenSize, setChosenSize] = useState();
  const [loaded, setLoaded] = useState(false);
  const chosenValues = useMemo(() => {
    return {
      size: chosenSize,
    };
  }, [chosenSize]);

  const onChange = (key, value) => {
    if (key === 'size') {
      setChosenSize(value);
    }
  };

  const sorter = (a, b) => {
    const sizeA = a.size.toUpperCase();
    const sizeB = b.size.toUpperCase();
    if (sizeA < sizeB) {
      return -1;
    }
    if (sizeA > sizeB) {
      return 1;
    }

    return 0;
  };

  useEffect(() => {
    loaded &&
      onSelect(variantsPickerItems.find((e) => e.size === chosenValues.size));
  }, [loaded, variantsPickerItems, onSelect, chosenValues]);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return loaded ? (
    <div>
      {Object.entries(choices).map(([k, v]) => (
        <ReactSelect
          key={k}
          placeholder={v}
          options={variantsPickerItems.sort(sorter).map((item) => {
            return {
              value: item[k + 'Key'],
              label: (
                <span
                  className={clsx(
                    classPrefix + '__variants-picker__option',
                    !item.isInStock &&
                      classPrefix + '__variants-picker__option--disabled'
                  )}
                >
                  <span
                    className={classPrefix + '__variants-picker__option__label'}
                  >
                    {item[k]}
                  </span>
                  <ProductStock
                    className={
                      classPrefix + '__variants-picker__option__stock-status'
                    }
                    isInStock={item.isInStock}
                    hasLowStock={item.hasLowStock}
                    stockStatusDescription={item.stockStatusDescription}
                  />
                </span>
              ),
              isInStock: item.isInStock,
            };
          })}
          isOptionDisabled={(option) => !option.isInStock}
          onChange={({ value }) => onChange(k, value)}
          classNames={{
            control: (state) => classPrefix + '__variants-picker__control',
            indicatorSeparator: (state) =>
              classPrefix + '__variants-picker__indicator-separator',
            placeholder: (state) =>
              classPrefix + '__variants-picker__placeholder',
            dropdownIndicator: (state) =>
              classPrefix + '__variants-picker__dropdown-indicator',
            menu: (state) => classPrefix + '__variants-picker__menu',
          }}
        />
      ))}
    </div>
  ) : (
    <div></div>
  );
};

export default VariantsPicker;
